import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import Spinner from '../partials/Spinner';
import { AuthContext } from '../../context/authContext';
import { Context } from '../../types/interfaces';
import UsersList from '../partials/UsersList';
import styles from './Admin.module.scss';

const Admin: React.FC = () => {
  const context = useContext(AuthContext) as Context;
  const [loading, setLoading] = useState(false);
  const { users, setUsers } = context;

  useEffect(() => {
    if (!users) {
      setLoading(true);
      axios
        .get(`${process.env.REACT_APP_SERVER}/api/users`)
        .then(res => {
          setUsers(res.data);
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
          console.error(err);
        });
    }
  }, [setUsers, users]);

  return (
    <main className={styles.main}>
      <h2>Database Users</h2>
      {loading ? (
        <Spinner />
      ) : users ? (
        <UsersList users={users} />
      ) : (
        <p>No users found.</p>
      )}
    </main>
  );
};

export default Admin;
